/**
 * Minimum rates are no longer enforced: the rate dropdown starts at the lowest step and the
 * previous per-skill minimum is only used as the preselected default.
 * The start is aligned to the default so it always appears in the list (e.g. 15.25 -> 0.25, 0.75, ...).
 */
export const RATE_STEP = 0.5;

export function getRateOptionsStart(defaultRate: number): number {
  return (defaultRate % RATE_STEP) || RATE_STEP;
}
